import { ReplicaType } from "types";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp5-mass-breakout-from-azkaban-alternative",
  name: `The Daily Prophet\n'Mass Breakout from Azkaban' (alternative)`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Mass Breakout from Azkaban' (alternative)",
  },
  origin: "Harry Potter and the Order of the Phoenix",

  category: replicaCategories.harryPotter,

  versions: [Version2],
};

export default data;
